import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/global/Buttons/Button';
import {
  OpaqueWrapper,
  ModalDescription,
  ModalWrapper
} from 'components/local/modals/styles/StyledComponents';
import Markdown from 'react-markdown';

const Modal = ({ handleAccept, handleClose, modalType, customWarning }) => {
  const { t } = useTranslation();
  const handleContinue = () => {
    handleClose();
    handleAccept();
  };

  const modalMessages = {
    submitSlot: {
      description: t('finishingSection.submitSlotDescription'),
      warning: t('finishingSection.warning'),
      accept: t('finishingSection.yesNextQuestion'),
      close: t('finishingSection.back')
    },
    submitSection: {
      description: t('finishingSection.submitSectionDescription'),
      warning: t('finishingSection.warning'),
      accept: t('finishingSection.yesCompleteSection'),
      close: t('finishingSection.back')
    },
    submitAssessment: {
      description: t('finishingSection.submitAssessmentDescription'),
      warning: t('finishingSection.submitAssessmentWarning'),
      accept: t('finishingSection.yesSubmitAssessment'),
      close: t('finishingSection.back')
    },
    leaveAssessment: {
      description: t('leaveAssessmentMessage.description'),
      warning: t('leaveAssessmentMessage.warning'),
      accept: t('leaveAssessmentMessage.accept'),
      close: t('leaveAssessmentMessage.close')
    },
    copyDetected: {
      warning: t('copyingMessage.warning'),
      description: t('copyingMessage.title'),
      accept: t('copyingMessage.understand'),
      close: t('copyingMessage.close')
    },
    tabChangeDetected: {
      warning: t('tabChangeMessage.warning'),
      description: t('tabChangeMessage.title'),
      accept: t('tabChangeMessage.understand'),
      close: t('copyingMessage.close')
    },
    browserCaptureDetected: {
      warning: t('browserCaptureMessage.warning'),
      description: t('browserCaptureMessage.title'),
      accept: t('browserCaptureMessage.understand'),
      close: t('copyingMessage.close')
    }
  };

  const { description, warning, accept, close } = modalMessages[modalType];

  return (
    <OpaqueWrapper id="modal">
      <ModalWrapper>
        <ModalDescription className="bold">{description}</ModalDescription>
        <ModalDescription margin="0 0 24px 0">
          {warning ? warning : <Markdown>{customWarning}</Markdown>}
        </ModalDescription>
        <div className="buttonContainer">
          <div className="btn-left">
            <Button
              className="inverted"
              isFullWidth={true}
              onClick={handleClose}
              text={close}
              textTransform="uppercase"
            />
          </div>
          <div className="btn-right">
            <Button
              className="warning"
              isFullWidth={true}
              onClick={handleContinue}
              text={accept}
              textTransform="uppercase"
            />
          </div>
        </div>
      </ModalWrapper>
    </OpaqueWrapper>
  );
};

Modal.propTypes = {
  handleAccept: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  modalType: PropTypes.oneOf([
    'submitSlot',
    'submitSection',
    'submitAssessment',
    'leaveAssessment',
    'copyDetected',
    'tabChangeDetected',
    'browserCaptureDetected'
  ]).isRequired,
  customWarning: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

export default Modal;
